// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"58":"12f91a8e854ac6cf","60":"77c09b98d8480608","83":"73f0feefd8c08fe1","677":"970e58ed941676c3"}[chunkId] + ".js";
};